module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"insurerStatus":"Insurer Status","insurerDecision":"Insurer Decision"},"fr":{"insurerStatus":"Statut de l\u0027assureur","insurerDecision":"Décision de l\u0027assureur"}}')
  delete Component.options._Ctor
}
